const routes = [
  {
    path: "/local-lotacao-x-beneficios",
    name: "local-lotacao-x-beneficios",
    meta: {
      allowedPermissions: ["local_lotacao_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/LocalLotacaoXBeneficios/LocalLotacaoXBeneficiosHome.vue"),
  },
  {
    path: "/local-lotacao-x-beneficios/novo",
    name: "local-lotacao-x-beneficios-novo",
    meta: {
      allowedPermissions: ["local_lotacao_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/LocalLotacaoXBeneficios/LocalLotacaoXBeneficiosCad.vue"),
  },
  {
    path: "/local-lotacao-x-beneficios/editar/:id",
    name: "local-lotacao-x-beneficios-editar",
    meta: {
      allowedPermissions: ["local_lotacao_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/LocalLotacaoXBeneficios/LocalLotacaoXBeneficiosEdit.vue"),
  },
];

export default routes;
